import React from 'react';
// import PropTypes from 'prop-types';
import './loading.css';
import { BaseComponent } from '../../base-component';
import { COMPONENT } from '../../ui-event';
import * as animationData from '../../animation/loading.json'
import { genClassName } from '../../utils'
// import imgsrc from '../../images/loading.gif';


export default class loading extends BaseComponent {
    state = {
        showList:[]
    }
    componentWillMount() {
        this.eventMgr.on(COMPONENT.LOADING.TOGGLE, (show) => {
            let {showList} = this.state;
            show? showList.push('loading') : showList.shift();
            this.setState({ showList })
            if(showList.length){
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.setState({showList: []});
                    this.eventMgr.emit(COMPONENT.TOAST.POPUP, '网络有点不好诶！稍后再试吧！')
                }, 20000);
            }
            else clearTimeout(this.timer);
        })
    }
    render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData,
        };
        let { showList } = this.state;
        let loadingClass = genClassName({
            'modal': true,
            'loading': true,
            'modal-hidden': !showList.length
        })
        return (
            <div className={loadingClass}>
                <div className="loading-image" ></div>
            </div>
        )
    }
}

loading.defaultProps = {

};

loading.propTypes = {

};





// WEBPACK FOOTER //
// ./src/components/loading/index.js